module.exports = __webpack_public_path__ + "img/celc_logo.5f1a4e00.png";